// extracted by css-extract-rspack-plugin
export default {"cls1":"Autocomplete-cls1_PK4","cls2":"Autocomplete-cls2_Ds8 Autocomplete-cls1_PK4"};